import BusinessInformationForm from './BusinessInformationForm'

export default BusinessInformationForm
